import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Theme } from '../../../../theme/theme';

export type AccordionPanelVariant = 'default' | 'embedded';

interface Props {
  variant: AccordionPanelVariant;
  theme: Theme;
}

export const StyledAccordionPanel = styled(motion.div)(({ variant, theme }: Props) => ({
  backgroundColor: 'white',
  overflow: 'hidden',

  ...(variant === 'default' && {
    borderBottomLeftRadius: theme.radii.xl,
    borderBottomRightRadius: theme.radii.xl,
  }),
}));
